import { useRouter } from 'next/navigation';
import PriceListCard from './price-list-card';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

export const PriceListStudent = () => {
  const router = useRouter();
  const { me } = useCustomerStore();

  return (
    <div className="flex gap-4">
      <PriceListCard
        title={'"I AM FREE" zvýraznenie životopisu'}
        description="1 mesiac"
        price="10 € bez DPH"
        buttonText="Zakúpiť"
        buttonAction={() => {
          me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
        }}
      />
      <PriceListCard
        title={'"I AM FREE AT SOME TIME" zvýraznenie životopisu'}
        description="1 mesiac"
        price="10 € bez DPH"
        buttonText="Zakúpiť"
        buttonAction={() => {
          me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
        }}
      />
    </div>
  );
};
